import { BriefcaseFilled, CheckmarkRegular } from '@fluentui/react-icons';
import moment from 'moment-timezone';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AixQuill } from '../../../AixQuill';
import { Text } from '../../../Text';
import { QUILL_DEFAULT_FORMATS } from '../../../Utils';

export interface HomeworkListItemProps {
  isDone: boolean;
  homeworkName: string;
  homeworkId: string;
  homeworkDueDate: string;
  homeworkDescription: string;
  homeworkMinutes?: string;
  homeworkPoints?: string;
  homeworkTeamsUrl?: string;
  onAcceptClick?(homeworkId: string): void;
  onTenantWorkClick?(homeworkId: string): void;
}

export const HomeworkListItem: React.FC<HomeworkListItemProps> = (props) => {
  const { t } = useTranslation();

  return (
    <li className="homeworkListItem">
      <div className="flex flex-col items-center justify-center date">
        <div className="day">{moment(props.homeworkDueDate).date()} </div>
        <div className="month">{moment(props.homeworkDueDate).format('MMM')}</div>
      </div>
      <div className="flex flex-col gap-2 data">
        <Text size="lg" weight="bold">
          {props.homeworkName}
        </Text>
        <Text weight="bold">{`Fällig am: ${moment(props.homeworkDueDate).format('LLL')}`}</Text>
        <AixQuill
          readOnly
          className="instructionsReadonlyHomeworkQuill"
          modules={{
            toolbar: false,
          }}
          formats={QUILL_DEFAULT_FORMATS}
          theme=""
          defaultValue={props.homeworkDescription || ''}
        />
      </div>
      <div className="actions">
        <div className="flex items-center gap-3 iconWrapper">
          <button
            type="button"
            className="homeworkActionButton"
            aria-label={t('classbook:assignmentslisting:accept_homework_aria', {
              defaultValue: 'Aufgabe als kontrolliert markieren',
            })}
            onClick={() => {
              if (props.onAcceptClick) {
                props.onAcceptClick(props.homeworkId);
              }
            }}
          >
            <CheckmarkRegular
              className={`homeworkActionIcon ${props.isDone ? 'acceptedIcon' : 'acceptIcon'}`}
            />
          </button>
          {props.homeworkTeamsUrl && props.homeworkTeamsUrl.length > 0 && (
            <button
              type="button"
              className="homeworkActionButton"
              aria-label={t('classbook:assignmentslisting:open_in_teams_aria', {
                defaultValue: 'In Teams öffnen',
              })}
              onClick={() => {
                if (props.onTenantWorkClick) {
                  props.onTenantWorkClick(props.homeworkId);
                }
              }}
            >
              <BriefcaseFilled className="homeworkActionIcon tenantWorkIcon" />
            </button>
          )}
        </div>
      </div>
    </li>
  );
};
